import React from "react";
import CreateMaintenanceRequest from "../../office/CreateMaintenanceRequest";

export default function MaintenanceCreateSection({
  onNotify,
  onRequestCreated,
  mastersFromParent = false,
  masters = null,
  mastersLoadError = "",
  editingRequest = null,
  onCancelEdit,
}) {
  const isEditing = Boolean(editingRequest?.id);

  return (
    <div
      id="md-create"
      className="user-builder-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">
          {isEditing ? `Edit request #${editingRequest.id}` : "New request"}
        </h3>
        <p className="user-builder-panel__hint">
          {isEditing
            ? "Update this request below, then save. Use Cancel edit to return to create mode."
            : "Log a new maintenance request. Use Edit in the directory to change an existing row here."}
        </p>
      </div>
      <CreateMaintenanceRequest
        mastersFromParent={mastersFromParent}
        masters={masters}
        mastersLoadError={mastersLoadError}
        onNotify={onNotify}
        onRequestCreated={onRequestCreated}
        editingRequest={editingRequest}
        onCancelEdit={onCancelEdit}
      />
    </div>
  );
}
